// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
    companiesQuery: string;
    companiesOutput: string;
    matching: This.CompanyNameMatching;
    outputType: This.CompanyNameMatchingOutputType;
    isUseAi: boolean;
    matchingStats: { total: number, ambiguous: number, notFound: number };
    companyType: This.CompanyNameMatchingCompanyType;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Toolbox-CompanyNameLookup',
    templateUrl: './CompanyNameLookup.html',
    styleUrls: ['./CompanyNameLookup.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CompanyNameLookup extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Toolbox.CompanyNameLookup';
    $isDialog = false;
    $Modules = $Modules;
    Toolbox = Toolbox;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    $validators: Record<number, ValidationRules> = {

    };
    var_companiesQuery = proxySignal<string>(undefined as any);
    var_companiesOutput = proxySignal<string>(undefined as any);
    var_matching = proxySignal<This.CompanyNameMatching>(undefined as any);
    var_outputType = proxySignal<This.CompanyNameMatchingOutputType>(undefined as any);
    var_isUseAi = proxySignal<boolean>(undefined as any);
    var_matchingStats = proxySignal<{ total: number, ambiguous: number, notFound: number }>(undefined as any);
    var_companyType = proxySignal<This.CompanyNameMatchingCompanyType>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get companiesQuery() { return component.var_companiesQuery() },
                set companiesQuery(value: string) { component.var_companiesQuery.set(value) },
                get companiesOutput() { return component.var_companiesOutput() },
                set companiesOutput(value: string) { component.var_companiesOutput.set(value) },
                get matching() { return component.var_matching() },
                set matching(value: This.CompanyNameMatching) { component.var_matching.set(value) },
                get outputType() { return component.var_outputType() },
                set outputType(value: This.CompanyNameMatchingOutputType) { component.var_outputType.set(value) },
                get isUseAi() { return component.var_isUseAi() },
                set isUseAi(value: boolean) { component.var_isUseAi.set(value) },
                get matchingStats() { return component.var_matchingStats() },
                set matchingStats(value: { total: number, ambiguous: number, notFound: number }) { component.var_matchingStats.set(value) },
                get companyType() { return component.var_companyType() },
                set companyType(value: This.CompanyNameMatchingCompanyType) { component.var_companyType.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {

        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this
            if (!isVariablesInitialized) this.screen.companiesQuery = (undefined)
            if (!isVariablesInitialized) this.screen.companiesOutput = (undefined)
            if (!isVariablesInitialized) this.screen.matching = (undefined)
            if (!isVariablesInitialized) this.screen.outputType = (This.CompanyNameMatchingOutputType.IdAndName)
            if (!isVariablesInitialized) this.screen.isUseAi = (false)
            if (!isVariablesInitialized) this.screen.matchingStats = (undefined)
            if (!isVariablesInitialized) this.screen.companyType = (This.CompanyNameMatchingCompanyType.All)
            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    async handler_ButtonBlock_7_click_executeMatching_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                await this.action_executeMatching($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_DropdownBlock_28_selectionChange_updateOutput_0($event: any, $scope: any): Promise<void> {
        let { resolution, resolutionIndex, $disabled }: { resolution: This.CompanyNameResolution, resolutionIndex: number, $disabled: any } = $scope ?? {}

        {
            let selection: any = $event?.value
            const { app, screen, output } = this
            try {
                await this.action_updateOutput($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_SearchableDropdownBlock_34_optionSelected_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { resolution, resolutionIndex, $disabled }: { resolution: This.CompanyNameResolution, resolutionIndex: number, $disabled: any } = $scope ?? {}

        {
            let $option: { id: string, name: string } | null = $event
            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    resolution.chosenOption = $option ? new This.CompanyNameResolutionOption($option) : undefined
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_SearchableDropdownBlock_34_optionSelected_updateOutput_1($event: any, $scope: any): Promise<void> {
        let { resolution, resolutionIndex, $disabled }: { resolution: This.CompanyNameResolution, resolutionIndex: number, $disabled: any } = $scope ?? {}

        {
            let $option: { id: string, name: string } | null = $event
            const { app, screen, output } = this
            try {
                await this.action_updateOutput($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async _SearchableDropdownBlock_collectionCode_34($scope: any): Promise<any> {
        let { app, screen, $pathSegments, $disabled, resolution, resolutionIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, resolution: This.CompanyNameResolution, resolutionIndex: number } = $scope ?? {}

        return (This.Customers.getEntryList())
    }

    _SearchableDropdownBlock_displayWith_34($option: any, $index: number, $scope: Record<string, any>) {
        const { app, screen, $pathSegments, $disabled, resolution, resolutionIndex } = $scope ?? {}

        const $label = `${$option.id} ${$option.name}`
        return $label ?? ''
    }

    async handler_DropdownBlock_22_selectionChange_updateOutput_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {
            let selection: any = $event?.value
            const { app, screen, output } = this
            try {
                await this.action_updateOutput($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_26_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    const clipboardItem = new ClipboardItem({
                        'text/plain': screen.companiesOutput
                    })
                    await navigator.clipboard.write([clipboardItem])
                    Sys.App.showNotification('success', 'Output copied to clipboard')
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {

        }
    }

    async action_executeMatching($event?: any) {
        const { app, screen, output } = this
        {
            try {
                Sys.App.spinnerText = 'Matching in progress...'
                screen.matching = await This.CompanyNameMatching.executeMatching(screen.companiesQuery, screen.isUseAi, screen.companyType)
                screen.matchingStats = {
                    total: screen.matching.resolutions.length,
                    ambiguous: screen.matching.resolutions.filter(res => res.options.length > 1).length,
                    notFound: screen.matching.resolutions.filter(res => res.options.length == 0).length,
                }
                await this.action_updateOutput($event)
                Sys.App.showNotification('success', 'Matching was successful')
            } finally {
                Sys.App.spinnerText = undefined
            }

        }
    }

    async action_updateOutput($event?: any) {
        const { app, screen, output } = this
        {
            function getLineOutput(option: This.CompanyNameResolutionOption) {
                if (screen.outputType.isOnlyId) return option?.id
                if (screen.outputType.isOnlyName) return option?.name
                return `${option?.id} ${option?.name}`
            }

            const lines = screen.companiesQuery.split('\n').map(query => {
                if (!query) return ''
                const res = screen.matching.resolutions.find(r => r.inputName == query)
                if (res.chosenOption) return getLineOutput(res.chosenOption)
                if (res.options.length == 1) return getLineOutput(res.options[0])
                if (res.options.length) return `##### Please pick a match for ${res.inputName}`
                return `##### No match found for ${res.inputName}`
            })
            screen.companiesOutput = lines.join('\n')
        }
    }
}
